import { FC, ReactNode, useState } from 'react';
import { Box, SxProps, Theme, TooltipProps, Typography } from '@mui/material';
import { CoreTooltip } from '../core-tooltip';
import { Colors } from '../../../constants';
import { ExclamationIcon } from '../../../icons';

interface ExclamationTooltipProps {
	title?: string | ReactNode;
	iconSx?: SxProps<Theme>;
	tooltipSx?: SxProps<Theme>;
	placement?: TooltipProps['placement'];
	placementOffset?: [number, number];
}

export const ExclamationTooltip: FC<ExclamationTooltipProps> = (props) => {
	const { title, placement, iconSx, tooltipSx, placementOffset } = props;
	const [open, setOpen] = useState(false);

	return (
		<CoreTooltip
			arrow
			placement={placement}
			tooltipSx={tooltipSx}
			placementOffset={placementOffset}
			open={open}
			onOpen={() => {
				setOpen(true);
			}}
			onClose={() => {
				setOpen(false);
			}}
			title={
				<Typography key="0" sx={{ color: Colors.red }}>
					{title}
				</Typography>
			}
		>
			<Box
				component={ExclamationIcon}
				sx={{
					ml: 0.5,
					width: 12,
					height: 12,
					...(open
						? {
								color: Colors.dark,
								cursor: 'pointer',
						  }
						: {}),
					...iconSx,
				}}
			/>
		</CoreTooltip>
	);
};
